import { render, staticRenderFns } from "./CRMLawcaseFinance.vue?vue&type=template&id=4afed019&scoped=true&"
import script from "./CRMLawcaseFinance.vue?vue&type=script&lang=js&"
export * from "./CRMLawcaseFinance.vue?vue&type=script&lang=js&"
import style0 from "./CRMLawcaseFinance.vue?vue&type=style&index=0&id=4afed019&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afed019",
  null
  
)

export default component.exports